// extracted by mini-css-extract-plugin
export default {"container":"style_container__Rufgf","title":"style_title__N6wRL","divider":"style_divider__+JMs+","children":"style_children__L0ijT","formFooter":"style_formFooter__CLpwt"};